var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters } from "vuex";
import { Loading } from 'element-ui';
import GlobalVue from "../../globalVue";
import _ from 'lodash';
import { UrlHelper } from "../../helper/UrlWrapper";
import PrintConfigService from '../../api/PrintConfigService';
import AddDialog from './AddDialog.vue';
import CopyConfigDialog from './CopyConfigDialog.vue';
import Preview from '../sourceCodePrint/component/sourceCodePreview.vue';
import ApplyClientsDialog from "../businessgoodsprice/components/ApplyClientsDialog.vue";
import NewApplyClientsDialog from "../businessgoodsprice/components/NewApplyClientsDialog.vue";
import DragPreview from './components/DragPreview.vue';
import { auth } from '../../helper/authDecorator';
var List = (function (_super) {
    __extends(List, _super);
    function List() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.total = 0;
        _this.listData = [];
        _this.clientStatus = [
            { label: '全部合作状态', value: '0' },
            { label: '已合作', value: '1' },
            { label: '已暂停', value: '2' },
            { label: '已结束', value: '3' }
        ];
        _this.groups = [];
        _this.pageTypeList = [];
        _this.sourceList = [
            { id: -1, name: '全部来源' },
            { id: 1, name: '系统默认' },
            { id: 2, name: '供应商添加' },
            { id: 3, name: '客户要求模板' },
        ];
        _this.formData = {
            text: '',
            cooperation_status: '0',
            group: 0,
            template_type: -1,
            source: -1,
        };
        _this.previewType = false;
        return _this;
    }
    List.prototype.created = function () {
        this.sourceCodeData = {
            "11667": {
                "type": "suppliercode",
                "name": "供应商打码",
                "width": "50",
                "height": "50",
                "qrcode_config": [
                    {
                        "key": "lgname",
                        "name": "",
                        "hidden": false,
                        "fontSize": "25",
                        "width": 102,
                        "height": 27,
                        "locked": false,
                        "x_coordinates": 20,
                        "y_coordinates": 37,
                        "value": "女上衣L（夏）"
                    },
                    {
                        "key": "lgasname",
                        "name": "货品别名",
                        "hidden": false,
                        "fontSize": "22",
                        "width": 90,
                        "height": 24,
                        "locked": false,
                        "x_coordinates": 20,
                        "y_coordinates": 94,
                        "value": ""
                    },
                    {
                        "key": "std",
                        "name": "规格",
                        "hidden": false,
                        "fontSize": "25",
                        "width": 52,
                        "height": 27,
                        "locked": false,
                        "x_coordinates": 290,
                        "y_coordinates": 91,
                        "value": ""
                    },
                    {
                        "key": "flgtname",
                        "name": "货品大类",
                        "hidden": false,
                        "fontSize": "23",
                        "width": 94,
                        "height": 25,
                        "locked": false,
                        "x_coordinates": 290,
                        "y_coordinates": 155,
                        "value": "系数测试"
                    },
                    {
                        "key": "lgtname",
                        "name": "货品小类",
                        "hidden": false,
                        "fontSize": "24",
                        "width": 98,
                        "height": 26,
                        "locked": false,
                        "x_coordinates": 20,
                        "y_coordinates": 154,
                        "value": "系数测试"
                    },
                    {
                        "key": "lgsno",
                        "name": "货品编码",
                        "hidden": true,
                        "fontSize": 12,
                        "width": 0,
                        "height": 0,
                        "locked": false,
                        "value": "10001"
                    },
                    {
                        "key": "brandname",
                        "name": "品牌",
                        "hidden": true,
                        "fontSize": 12,
                        "width": 0,
                        "height": 0,
                        "locked": false,
                        "value": ""
                    },
                    {
                        "key": "codedate",
                        "name": "打码日期",
                        "hidden": true,
                        "fontSize": 12,
                        "width": 0,
                        "height": 0,
                        "locked": false,
                        "value": "2021-11-09"
                    },
                    {
                        "key": "storeenvironm",
                        "name": "存储条件",
                        "hidden": true,
                        "fontSize": 12,
                        "width": 0,
                        "height": 0,
                        "locked": false,
                        "value": ""
                    },
                    {
                        "key": "shelflife",
                        "name": "保质期",
                        "hidden": true,
                        "fontSize": 12,
                        "width": 0,
                        "height": 0,
                        "locked": false,
                        "value": "0"
                    },
                    {
                        "key": "producer",
                        "name": "产地",
                        "hidden": true,
                        "fontSize": 12,
                        "width": 0,
                        "height": 0,
                        "locked": false,
                        "value": ""
                    },
                    {
                        "key": "supname",
                        "name": "供应商名称",
                        "hidden": true,
                        "fontSize": 12,
                        "width": 0,
                        "height": 0,
                        "locked": false,
                        "value": "湖北鸿润生态农业发展有限公司\/徐一言"
                    },
                    {
                        "key": "shelflife",
                        "name": "供应商别名",
                        "hidden": true,
                        "fontSize": 12,
                        "width": 0,
                        "height": 0,
                        "locked": false,
                        "value": "0"
                    },
                    {
                        "key": "supsno",
                        "name": "供应商编码",
                        "hidden": true,
                        "fontSize": 12,
                        "width": 0,
                        "height": 0,
                        "locked": false,
                        "value": "4"
                    },
                    {
                        "key": "charge",
                        "name": "联系人",
                        "hidden": true,
                        "fontSize": 12,
                        "width": 0,
                        "height": 0,
                        "locked": false,
                        "value": "zmz"
                    },
                    {
                        "key": "mobile",
                        "name": "联系电话",
                        "hidden": true,
                        "fontSize": 12,
                        "width": 0,
                        "height": 0,
                        "locked": false,
                        "value": "15624978798"
                    },
                    {
                        "key": "addr",
                        "name": "地址",
                        "hidden": true,
                        "fontSize": 12,
                        "width": 0,
                        "height": 0,
                        "locked": false,
                        "value": null
                    },
                    {
                        "key": "region",
                        "name": "城市",
                        "hidden": true,
                        "fontSize": 12,
                        "width": 0,
                        "height": 0,
                        "locked": false,
                        "value": "北京市"
                    },
                    {
                        "key": "qrcode",
                        "name": "供应商货品二维码",
                        "hidden": false,
                        "width": 180,
                        "height": 190,
                        "locked": false,
                        "fontSize": 12,
                        "x_coordinates": 10,
                        "y_coordinates": 204,
                        "value": "http:\/\/140.143.163.151:8899\/AWApp\/certifitracesource\/164\/11667\/2021-11-09"
                    },
                    {
                        "key": "supasname",
                        "name": "供应商别名",
                        "hidden": true,
                        "fontSize": 12,
                        "width": 0,
                        "height": 0,
                        "value": "湖北鸿润生态农业发展有限公司\/徐一言"
                    }
                ]
            }
        };
    };
    List.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 211;
        }, 300);
        this.service = PrintConfigService.getInstance();
        if (this.template_type !== undefined) {
            this.formData.template_type = this.template_type;
        }
        this.getPrintConfigList();
        this.getClientGroups();
        this.getPageTypeList();
    };
    List.prototype.getClientGroups = function () {
        var _this = this;
        this.service.getClientGroups({
            isAll: 1,
            is_self: 1
        }).then(function (res) {
            _this.groups = Array.isArray(res.data.data) ? res.data.data : [];
        });
    };
    List.prototype.getPageTypeList = function () {
        var _this = this;
        this.service.getPageTypeList({ type: 2 }).then(function (res) {
            var data = res.data.data;
            _this.pageTypeList = [{ id: -1, name: '全部类型' }];
            _this.pageTypeList = _this.pageTypeList.concat(data || []);
        });
    };
    List.prototype.dialogClose = function () {
        this.previewType = false;
    };
    List.prototype.getPrintConfigList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var params = {
            keyword: this.formData.text,
            cooperation_status: this.formData.cooperation_status,
            group_id: this.formData.group,
            source: this.formData.source,
            template_type: this.formData.template_type,
        };
        Object.assign(params, pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getPrintConfigList(params).then(function (res) {
            if (res.data.success) {
                _this.listData = res.data.data;
                _this.total = res.data.total;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            console.log(211112);
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message);
            console.log(211111);
            loadingInstance.close();
        }).catch(function (err) {
            console.log(221111);
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    List.prototype.getSelectClientIds = function (key) {
        if (key === void 0) { key = 'business_id'; }
        return _.reduce(this.selectRows, function (ori, newItem) {
            return ori += ori ? (',' + newItem[key]) : newItem[key];
        }, '');
    };
    List.prototype.addConfig = function () {
        GlobalVue.$emit("addTab", {
            component: AddDialog,
            title: "新增模板",
            name: "addPrintConfig",
            showExist: true,
        });
    };
    List.prototype.edit = function (row) {
        GlobalVue.$emit("addTab", {
            component: AddDialog,
            title: "编辑模板",
            name: "editPrintConfig",
            showExist: true,
            cprops: {
                rowData: row,
                user: this.user
            }
        });
    };
    List.prototype.preview = function (row) {
        if (row.template_type === 21) {
            var mm2px = 3.78;
            var width = 160 * mm2px + 50;
            var height = 140 * mm2px + 100;
            var instance = this.$dialog(DragPreview, {
                data: {
                    template_id: row.template_id,
                }
            }, {
                title: "预览",
                width: width,
                height: height,
                zIndex: 100000,
                closeBtn: true
            }).instance;
            return;
        }
        if (row.template_type !== 9) {
            var url = "./static/js/print/print2.html";
            url = UrlHelper.addParam(url, 'type', "printTemplate");
            url = UrlHelper.addParam(url, 'template_id', row.template_id);
            url = UrlHelper.addParam(url, 'token', this.user.token);
            UrlHelper.windowOpenIntercept(url);
            window._czc.push(["_trackEvent", '打印列表', '打印预览']);
        }
        else {
            this.previewType = true;
        }
    };
    List.prototype.search = function () {
        this.$refs.pagination.clear();
        this.getPrintConfigList();
    };
    List.prototype.pageChange = function (pager) {
        this.getPrintConfigList();
    };
    List.prototype.selectionChange = function (rows) {
        if (rows.length > 1) {
            var templateTypes = rows.map(function (row) { return row.template_type; });
            var allDeliveryTypes = templateTypes.every(function (type) { return type === 3 || type === 8; });
            var noneDeliveryTypes = templateTypes.every(function (type) { return type !== 3 && type !== 8; });
        }
        this.selectRows = rows;
    };
    List.prototype.deleteConfig = function () {
        var _this = this;
        if (!this.selectRows.length) {
            this.$message.error("请选择模板！");
            return;
        }
        if (this.selectRows.length != 1) {
            this.$message.error('只能选择一个模板！');
            return;
        }
        if (this.selectRows[0].source === 3) {
            this.$message.warning('客户要求模板不可删除');
            return;
        }
        this.$confirm('您确定要删除模板吗？删除后此模板的应用客户需要重新设置模板！', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                var template_id = _this.selectRows[0].template_id;
                _this.service.delConfigs({ template_id: template_id }).then(function (res) {
                    if (res.data.success) {
                        _this.$message.success('删除成功！');
                        _this.search();
                    }
                    window._czc.push(["_trackEvent", '打印列表', '删除模板']);
                }).catch(function (err) {
                    _this.$message.error(err.msg || err.message);
                });
            }
        }).catch(function () {
        });
    };
    List.prototype.applyClients = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择模板！');
            return;
        }
        if (this.selectRows.length != 1) {
            this.$message.error('只能选择一个模板！');
            return;
        }
        if (this.selectRows[0].template_type === 5) {
            this.$message.warning('采购入库无需设置应用客户');
            return;
        }
        if (this.selectRows[0].template_type === 6) {
            this.$message.warning('调拨单无需设置应用客户');
            return;
        }
        var instance = this.$dialog(ApplyClientsDialog, {
            data: {
                template_id: this.selectRows[0].template_id,
                supplier_to_business_id: (this.selectRows[0].supplier_to_business_id || '').split(','),
                clientStatus: this.clientStatus
            }
        }, {
            title: "应用客户",
            width: 560,
            height: 400
        }).instance;
        instance.$on("applyClients:ok", function () {
            window._czc.push(["_trackEvent", '打印列表', '应用客户']);
            _this.getPrintConfigList(_this.$refs.pagination.pager);
        });
    };
    List.prototype.applyClient = function (row) {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择模板！');
            return;
        }
        if (this.selectRows.length != 1) {
            this.$message.error('只能选择一个模板！');
            return;
        }
        if (this.selectRows[0].template_type === 5) {
            this.$message.warning('采购入库无需设置应用客户');
            return;
        }
        if (this.selectRows[0].template_type === 6) {
            this.$message.warning('调拨单无需设置应用客户');
            return;
        }
        if (this.selectRows[0].source === 3) {
            this.$message.warning('客户要求模板不可应用客户');
            return;
        }
        var templateType = this.selectRows[0].template_type;
        var isDeliveryType = templateType === 3 || templateType === 8;
        var DialogComponent = isDeliveryType ? NewApplyClientsDialog : ApplyClientsDialog;
        this.service.getprintClient({
            template_id: this.selectRows[0].template_id
        }).then(function (res) {
            if (res.data.success) {
                var data = res.data.data;
                var dialogData = {
                    descHtml: "\u6309\u7EC4\u751F\u6548\uFF1A\u9664\u5F53\u524D\u8BE5\u5BA2\u6237\u5206\u7EC4\u4E0B\u6240\u6709\u5BA2\u6237\u5E94\u7528\u6B64\u6253\u5370\u6A21\u677F\uFF0C\u540E\u7EED\u6DFB\u52A0\u5230\u8BE5\u7EC4\u4E0B\u7684\u5BA2\u6237\u4E5F\u9ED8\u8BA4\u5E94\u7528\u8BE5\u6253\u5370\u6A21\u677F<br/>\n                        \u4E34\u65F6\u5BA2\u6237\u5206\u7EC4\uFF1A\u6240\u6709\u65B0\u6CE8\u518C\u7684\u7528\u6237\u4F1A\u81EA\u52A8\u8FDB\u5165\u4E34\u65F6\u5BA2\u6237\u5206\u7EC4\uFF0C\u5982\u9700\u5355\u72EC\u7BA1\u7406\u5BA2\u6237\u8BF7\u5728\u5BA2\u6237\u5206\u7EC4\u4E2D\u8C03\u6574",
                    template_id: _this.selectRows[0].template_id,
                    group_ids: data.group_ids || [],
                    requiredChooseNum: false,
                };
                if (isDeliveryType) {
                    var shopIds = data.shop_supplier_to_business_ids || [];
                    dialogData.supplier_to_business_ids = shopIds;
                    dialogData.business_ids = data.business_ids || [];
                }
                else {
                    dialogData.supplier_to_business_ids = data.supplier_to_business_ids || [];
                }
                var dialog = _this.$dialog(DialogComponent, {
                    data: dialogData,
                    showEmpty: true
                }, {
                    title: "应用客户",
                    width: 640,
                    height: 530
                });
                dialog.instance.$on("submit", function (res) {
                    var loadingInstance = Loading.service({ fullscreen: true });
                    var business_info = res.business_info;
                    var group_id = business_info.filter(function (item) { return item.is_set_group == 1; }).map(function (item) {
                        if (item.is_set_group == 1) {
                            return item.group_id;
                        }
                    });
                    var params = {
                        template_id: _this.selectRows[0].template_id,
                        group_ids: group_id.join(','),
                        is_alert: '1',
                    };
                    if (isDeliveryType) {
                        var businessIds_1 = [];
                        var businessShopMap_1 = {};
                        business_info.forEach(function (group) {
                            if (group.children && group.children.length > 0) {
                                group.children.forEach(function (business) {
                                    var supplierId = parseInt(business.supplier_to_business_id);
                                    if (supplierId && !businessIds_1.includes(supplierId)) {
                                        businessIds_1.push(supplierId);
                                    }
                                    if (business.is_set_group != 3 && business.shop_id && business.shop_id.length > 0) {
                                        businessShopMap_1[supplierId] = business.shop_id;
                                    }
                                    else {
                                        businessShopMap_1[supplierId] = [];
                                    }
                                });
                            }
                        });
                        params.supplier_to_business_ids = businessIds_1.join(',');
                        params.business_shop_map = JSON.stringify(businessShopMap_1);
                        if (res.business_ids && res.business_ids.length > 0) {
                            params.business_ids = JSON.stringify(res.business_ids);
                        }
                    }
                    else {
                        var supplier_to_business_ids = res.supplier_to_business_ids;
                        params.supplier_to_business_ids = supplier_to_business_ids.join(',');
                    }
                    _this.service.applyClients(params).then(function (res) {
                        if (res.data.success) {
                            if (res.data.msg == '设置成功') {
                                loadingInstance.close();
                                _this.$message.success('应用客户成功！');
                                _this.getPrintConfigList();
                            }
                            else {
                                loadingInstance.close();
                                _this.$confirm(res.data.msg, '提示', {
                                    customClass: 'confirm'
                                }).then(function (res) {
                                    if (res) {
                                        _this.service.applyClients(Object.assign({}, params, { is_alert: '0' })).then(function (res) {
                                            if (res.data.success) {
                                                _this.$message.success('应用客户成功！');
                                                _this.getPrintConfigList();
                                            }
                                            else {
                                                _this.$message.error(res.data.msg);
                                            }
                                        });
                                    }
                                }).catch(function () {
                                });
                            }
                        }
                        else {
                            loadingInstance.close();
                            _this.$message.error(res.data.msg);
                        }
                    });
                });
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    List.prototype.copyConfig = function () {
        var _this = this;
        if (!this.selectRows || !this.selectRows.length) {
            this.$message.error('请先选择模板！');
            return;
        }
        if (this.selectRows.length != 1) {
            this.$message.error('只能选择一个模板！');
            return;
        }
        var instance = this.$dialog(CopyConfigDialog, {
            data: {
                rowData: this.selectRows[0],
                clientStatus: this.clientStatus
            }
        }, {
            title: "复制模板",
            width: 560,
            height: 400
        }).instance;
        instance.$on("copyConfig:ok", function () {
            window._czc.push(["_trackEvent", '打印列表', '复制模板']);
            _this.getPrintConfigList(_this.$refs.pagination.pager);
        });
    };
    List = __decorate([
        auth('16001'),
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            })),
            components: {
                'preview': Preview
            },
        })
    ], List);
    return List;
}(Vue));
export default List;
